import React, { useState, useEffect } from "react";
import { message, Input, Form, Modal, InputNumber } from "antd";
import useAxios from "axios-hooks";
import { useTranslation } from "react-i18next";
import { useForm } from "antd/lib/form/Form";
import { Resource } from "../../../../../api/common";
import { PassportDetail } from "./PassportDetail";
import Drawer from "../../../../../components/ui@concular/Drawer";

export const Matches = ({ visible, onClose, selectedMatch }: any) => {
   const { id, match_count, matches } = selectedMatch;
   const [matchingList, setMatchingList] = useState<any>(matches);
   const [t] = useTranslation();

   const MatchingTemplate = (props: any) => {
      const { data: dataMatchingTemp, dataDemand } = props;
      const [passportSpecificationDemand, setPassportSpecificationDemand] =
         useState<any>();
      const [showPassportDetailDemand, setShowPassportDetailDemand] =
         useState<boolean>(false);
      const [showSendRequest, setShowSendRequest] = useState<boolean>(false);
      const [form] = useForm();
      const [distanceData, setDistanceData] = useState<any>({});
      console.log("dataMatchingTemp", dataMatchingTemp);
      const [{ loading: confirmLoading }, addRequest] = useAxios(
         {
            url: `${Resource.path.getRequestUrlHub(dataDemand.id)}`,
            method: "POST"
         },
         { manual: true, useCache: false }
      );
      const [{ data: getDistance }] = useAxios(
         {
            url: `${Resource.path.calDistanceBetHub}`,
            method: "POST",
            data: {
               source_id: dataMatchingTemp.locations_id
                  ? dataMatchingTemp.locations_id
                  : dataMatchingTemp.building_id,
               dest_id: dataDemand.locations_id,
               type: dataMatchingTemp.locations_id ? "mat_dem" : "build_dem"
            },
            timeout: 900000
         },
         { manual: false, useCache: true }
      );
      //dataMatchingTemp.product_group_id
      const { product_name, amount_unit_op, amount_op, selling_id } =
         dataMatchingTemp;
      const showDetailPageDemand = (material: any) => {
         setPassportSpecificationDemand(material);
         setShowPassportDetailDemand(true);
      };
      const onCloseDetailDemand = () => {
         setShowPassportDetailDemand(false);
         setPassportSpecificationDemand(null);
      };

      const handleOk = async () => {
         const data = form.getFieldsValue();

         await addRequest({
            data: {
               selling_id: selling_id,
               amount: data.quantity,
               proposal_price: data.price_proposal,
               comments: data.comments,
               product_name
            }
         })
            .then(() => {
               form.resetFields();
               setShowSendRequest(false);
               message.success("Request sent successfully");
            })
            .catch((error) => {
               console.log(error);
               message.error(t("buildingOperations.errorMessage"));
            });
      };

      const handleCancel = () => {
         setShowSendRequest(false);
      };

      const [pgData, setPgData] = useState<any>();
      const [{ data: productGroupData }] = useAxios(
         {
            url: `${Resource.path.getProductGroupDetails}/${dataMatchingTemp.product_group_id}`,
            method: "GET"
         },
         { manual: false }
      );

      useEffect(() => {
         if (productGroupData?.data) {
            console.log("productGroupData", productGroupData);
            setPgData(productGroupData?.data);
         }
         if (getDistance?.data) {
            setDistanceData(getDistance.data);
         }
      }, [productGroupData, getDistance]);

      return (
         <>
            <div
               className="matching-item match"
               onClick={() => {
                  showDetailPageDemand(dataMatchingTemp);
               }}
            >
               <div className="inner">
                  {/*  <Progress type="circle" strokeColor={{
                '0%': '#108ee9',
                '100%': '#87d068',
            }} percent={95} width={40} /> */}
                  <div className="matching-state">
                     <figure className="match">
                        {dataMatchingTemp?.images && (
                           <img src={dataMatchingTemp?.images[0]?.object_url} />
                        )}
                        {!dataMatchingTemp?.images && (
                           <img src="data:image/png;base64,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" />
                        )}
                     </figure>
                  </div>
                  <div className="item-name">
                     <strong>{product_name}</strong>
                     <span className="amount">
                        {amount_op} {amount_unit_op}
                     </span>
                     {/*                 <Button type="primary" className="more-details" onClick={() => { showDetailPageDemand(dataMatchingTemp) }}>Details</Button>
                      */}{" "}
                  </div>
                  <div className="evaluation">
                     <dl>
                        {!!distanceData?.Distance && (
                           <>
                              <dt>{t("default.distance")}: </dt>
                              <dd>{distanceData.Distance.toFixed(1)} km</dd>
                           </>
                        )}

                        {/* <dt className="eva-result">Savings:</dt>
                        <dd className="eva-result">-3.8 tCO2-eq</dd> */}
                     </dl>
                  </div>
                  <div className="actions">
                     {/*<strong className="price"><span>Estimated price:</span> 50-75 €/piece</strong>*/}
                     <div className="link"></div>
                     {/* <Button type="primary" className="send-request" onClick={() => {
                        setShowSendRequest(true);
                    }}>Send request</Button> */}
                  </div>
               </div>
            </div>
            {showPassportDetailDemand && (
               <PassportDetail
                  visible={showPassportDetailDemand}
                  showRequestBtn
                  onClose={onCloseDetailDemand}
                  passportSpecification={passportSpecificationDemand}
                  demand_id={dataDemand.id}
                  dataDemand={dataDemand}
               />
            )}
            {showSendRequest && (
               <Modal
                  visible={showSendRequest}
                  okText={"Send"}
                  onOk={handleOk}
                  confirmLoading={confirmLoading}
                  onCancel={handleCancel}
               >
                  <div className="requestform">
                     <div className="product">
                        <h3>
                           {dataMatchingTemp?.manufacturer}{" "}
                           {dataMatchingTemp.product_name}
                        </h3>
                     </div>
                     <Form
                        name="request_form"
                        form={form}
                        initialValues={{ quantity: dataDemand.amount }}
                     >
                        <Form.Item
                           name="quantity"
                           label={t("materialRequestForm.quantity")}
                           rules={[{ required: true }]}
                        >
                           <InputNumber
                              addonAfter={dataMatchingTemp.product_unit}
                              min={1}
                           />
                        </Form.Item>
                        <Form.Item
                           name="price_proposal"
                           label={t("materialRequestForm.priceProposal")}
                           rules={[{ required: true }]}
                        >
                           <InputNumber
                              addonAfter={"€/" + dataMatchingTemp.product_unit}
                              min={1}
                           />
                        </Form.Item>
                        <Form.Item
                           name="comments"
                           label={t("materialRequestForm.comments")}
                        >
                           <Input.TextArea />
                        </Form.Item>
                     </Form>
                  </div>
               </Modal>
            )}
         </>
      );
   };

   return (
      <Drawer
         placement="right"
         closable={true}
         width={600}
         visible={visible}
         onClose={onClose}
      >
         <div>
            {match_count && match_count > 0 && (
               <div className="matches">
                  <h4>
                     {match_count} {t("default.matches")}
                  </h4>
                  {matchingList &&
                     matchingList.length > 0 &&
                     matchingList.map((record: any) => (
                        <MatchingTemplate
                           dataDemand={selectedMatch}
                           key={record.id}
                           data={record}
                        />
                     ))}
               </div>
            )}
         </div>
      </Drawer>
   );
};
